// extracted by mini-css-extract-plugin
export default {"form_control":"Textarea_form_control__idEI3","form_control__label":"Textarea_form_control__label__zwysO","form_control__label__option":"Textarea_form_control__label__option__HrINd"};